import React, {PureComponent} from "react"
import {isEmpty} from "lodash"
import {Hr} from "@irati/ui/src/Layout"
import Markdown from "@irati/ui/src/Markdown"
import {FormattedMessage} from "@irati/utils/lang"
import {Reward} from "@irati/types"
import SectionTitle from "./styled/SectionTitle"

interface Props {
  reward: Reward
  showHr: boolean
}

export default class RewardContactInfo extends PureComponent<Props> {
  static defaultProps = {
    showHr: true
  }

  render() {
    const {reward, showHr} = this.props

    return isEmpty(reward.contactInfo) ? null : (
      <section>
        {showHr && <Hr large />}
        <SectionTitle>
          <FormattedMessage id="reward.detail.contactInfo.title" />
        </SectionTitle>
        <Markdown source={reward.contactInfo} />
      </section>
    )
  }
}
